import ProvisionCard from "../ProvisionCard/ProvisionCard";
import "./ProvisionGrid.css";

function ProvisionGrid({
  products,
  onView,
  onEdit,
  onDelete,
}) {
  return (
    <div className="provision-grid">
      {products.map((product) => (
        <ProvisionCard
          key={product._id}
          product={product}
          onView={onView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}

export default ProvisionGrid;